// extracted by mini-css-extract-plugin
export var avatar = "_kv-3";
export var avatarContainer = "_kv-2";
export var avatarSpacer = "_kv-5";
export var avatarSpacerContainer = "_kv-4";
export var avatarStackContainer = "_kv-1";
export var bubble = "_kv-0";
export var remainderBubble = "_kv-6";